import { render, staticRenderFns } from "./schoolroll.vue?vue&type=template&id=192e9898&scoped=true"
import script from "./schoolroll.vue?vue&type=script&lang=ts"
export * from "./schoolroll.vue?vue&type=script&lang=ts"
import style0 from "./schoolroll.vue?vue&type=style&index=0&id=192e9898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e9898",
  null
  
)

export default component.exports